import { CalendarEvent, ManagementData } from 'store/modules/management_store/types';
import Api from '../api';
import { ensureOk } from '../ensure_ok';

export interface RepresentantCompanyCounters {
  id: number;
  boletins: number;
  mensagens: number;
  portais: number;
  gerencia_documentos: boolean;
}

export const getRepresentantDashboardCounters = (companyIds: number[]) =>
  Api.get<{ empresas: RepresentantCompanyCounters[] }>('/representante/dashboard', {
    params: { empresas: companyIds },
  }).then(ensureOk);

export const getCompanyPendingDocuments = (companyId: number) =>
  Api.get<{ total_documentos?: number }>('/documentos/count_documents', { params: { companyId } })
    .then(ensureOk)
    .then(({ data }) => Number(data?.total_documentos) || 0);

export interface RepresentantStateOpportunities {
  estado_id: number;
  estado_name: string;
  total: number;
}

export interface RepresentantCompanyOpportunities {
  id: number;
  hoje: number | null;
  vigentes: number | null;
  iminencia: number | null;
  baixa_concorrencia: number | null;
  estados: RepresentantStateOpportunities[] | null;
}

export const getRepresentantOpportunities = (companyIds: number[]) =>
  Api.get<{ empresas: RepresentantCompanyOpportunities[] }>(
    '/representante/dashboard/oportunidades',
    {
      params: { empresas: companyIds },
    },
  ).then(ensureOk);

export interface RepresentantCompanyManaged {
  id: number;
  tarefas_hoje: number;
  tarefas_atrasadas: number;
  andamentos: number;
}

export const getRepresentantManaged = (companyIds: number[], scope: string) =>
  Api.get<{ empresas: RepresentantCompanyManaged[] }>('/representante/dashboard/gerenciadas', {
    params: { empresas: companyIds, escopo: scope },
  }).then(ensureOk);

export type CompanyManagementSummary = ManagementData['management_summary'];

export const getCompanyManagementSummary = (companyId: number, scope: string) =>
  Api.get<CompanyManagementSummary>('/gerenciar_licitacoes/resumo.json', {
    params: { scope, companyId },
  })
    .then(ensureOk)
    .then(({ data }) => data);

export const getCompanyCalendarEvents = (
  companyId: number,
  scope: string,
  start: string,
  end: string,
) =>
  Api.get<{ events?: CalendarEvent[] }>('/gerenciar_licitacoes/calendario.json', {
    params: { scope, companyId, start, end, types: ['biddings', 'tasks', 'progress'] },
  })
    .then(ensureOk)
    .then(({ data }) => data.events || []);
